import { render, staticRenderFns } from "./feedbackReceived.vue?vue&type=template&id=7a5367f2&scoped=true"
import script from "./feedbackReceived.vue?vue&type=script&lang=js"
export * from "./feedbackReceived.vue?vue&type=script&lang=js"
import style0 from "./feedbackReceived.vue?vue&type=style&index=0&id=7a5367f2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5367f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5367f2')) {
      api.createRecord('7a5367f2', component.options)
    } else {
      api.reload('7a5367f2', component.options)
    }
    module.hot.accept("./feedbackReceived.vue?vue&type=template&id=7a5367f2&scoped=true", function () {
      api.rerender('7a5367f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedbackStatistics/components/feedbackReceived.vue"
export default component.exports